export default __webpack_public_path__ + "static/media/img-result-a-small.a0c8f643.png";